// react-router-dom components
import * as React from "react";
import { useState } from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import CoverLayout from "layouts/authentication/components/CoverLayout";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoginMutation } from "store/api/auth.api";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import schema from "validationSchema/login";

function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const logout = useLogout();

  const [login, { isLoading, isSuccess, isError, error }] = useLoginMutation();

  // handle the password visibility
  const handlePasswordvisibility = () => {
    setShowPassword((prev) => !prev);
  };

  // hange the input value change
  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  // handle submti form
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const data = {
      email: form?.email?.trim(),
      password: form?.password?.trim(),
    };

    try {
      const response = await login(data).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message));
        localStorage.setItem("loginData", JSON.stringify({ ...response?.data }));
        navigate("/dashboard");
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. Please try again in a few minutes.");
    }
  };

  // handle validate form
  const validateForm = () => {
    const result = schema.safeParse(form);

    if (!result.success) {
      const zodErrors = JSON.parse(result.error.message) ?? [];

      const firstMessage = zodErrors[0]?.message;
      if (firstMessage) {
        toast.error(firstMessage);
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <CoverLayout isLogin={true}>
      <SoftBox
        width="100%"
        borderRadius="xxl"
        overflow="hidden"
        sx={{ backgroundColor: "white.main" }}
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          display="flex"
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            width: "100%",
          }}
        >
          <SoftBox
            display="flex"
            sx={{ px: 3, py: 1, flexDirection: "column", gap: 2, width: "100%" }}
          >
            <SoftBox
              width="100%"
              display="flex"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <SoftTypography sx={{ fontSize: 24, color: "black.main" }}>
                Admin Login
              </SoftTypography>

              <SoftBox sx={{ textAlign: "center" }}>
                <SoftTypography
                  sx={{
                    fontSize: 16,
                    color: "lightblack.main",
                    display: { xs: "inline", lg: "block" },
                  }}
                >
                  Access your dashboard to manage schools, users, and
                </SoftTypography>
                <SoftTypography
                  sx={{
                    fontSize: 16,
                    color: "lightblack.main",
                    display: { xs: "inline", lg: "block" },
                  }}
                >
                  reports securely.
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox>
              <SoftBox sx={{ width: "100%" }}>
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography sx={{ fontSize: 16 }} color="darkgray" fontWeight="bold">
                    Email Address
                  </SoftTypography>

                  <SoftBox sx={{ position: "relative", width: "100%" }}>
                    <SoftInput
                      name="email"
                      value={form?.email}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      placeholder="Enter your email"
                      fontSize="14px"
                      sx={{
                        width: "100% !important",
                        py: "15px",
                      }}
                    />
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            <SoftBox>
              <SoftBox sx={{ width: "100%" }}>
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography
                    color="darkgray"
                    fontWeight="bold"
                    fontSize="14px"
                    sx={{
                      fontFamily: "Montserrat, sans-serif",
                    }}
                  >
                    Password
                  </SoftTypography>

                  <SoftBox sx={{ position: "relative", height: "45px", width: "100%" }}>
                    <SoftInput
                      name="password"
                      value={form?.password}
                      onChange={(e) => handleChange(e)}
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      fontSize="14px"
                      sx={{
                        width: "100% !important",
                        py: "15px",
                        pr: "40px",
                      }}
                    />

                    {/* Icon Button */}
                    <SoftBox
                      sx={{
                        position: "absolute",
                        top: "60%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        p: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <IconButton
                        onClick={handlePasswordvisibility}
                        sx={{
                          transition: "0.3s ease-in-out",
                        }}
                      >
                        {showPassword ? (
                          <VisibilityIcon sx={{ color: "primary.main", width: 28, height: 28 }} />
                        ) : (
                          <VisibilityOffIcon
                            sx={{ color: "primary.main", width: 28, height: 28 }}
                          />
                        )}
                      </IconButton>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox
            display="flex"
            sx={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              py: 2,
            }}
          >
            <SoftButton
              disabled={isLoading}
              onClick={handleSubmit}
              color="primary"
              sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
              variant="contained"
            >
              {isLoading ? "Loading..." : "Login"}
            </SoftButton>
            <SoftTypography
              component={Link}
              to="/authentication/forgot-password"
              fontWeight="normal"
              sx={{
                cursor: "pointer",
                color: "primary.main",
                fontSize: 16,
                textDecoration: "none",
              }}
            >
              Forgot password?
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
